export default "__VITE_ASSET__CeMqh$gJ__"